


































































































































































import Vue from "vue";
import Component from "vue-class-component";
import "../styles/model.scss";

@Component
export default class D20 extends Vue {}
